module.exports = require("classnames");


/*****************
 ** WEBPACK FOOTER
 ** external "classnames"
 ** module id = 68
 ** module chunks = 0
 **/